/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { Home, Profile } from 'features/components/base';
import { HelpPage, ViewMoreItems, About, SignTermsAndCondtions, AboutUs, Privacy,OurStory } from 'features/components/base/public';

import { EstateSalesRouter } from './EstateSalesRouter';
import { Notifications, Payment, Watching } from 'features/components/base/auth-pages';
import { LocationsRouter } from './LocationsRouter';
import { AdvanceSearchRouter } from './AdvanceSearchRouter';
import PaymentAutoDebit from 'features/components/base/auth-pages/payment-page/Payment-auto-debit';
import CategoryPage from 'features/components/base/category-page/CategoryPage';
import PaypalSDK from 'features/components/base/public/paypal-sdk/PaypalSDK';
import { PaymentMethodsAdd } from 'features/components/base/auth-pages/MyAccount';
import membershipplan from 'features/components/base/public/membershipplan/membershipplan';
import membershLandingPage from 'features/components/base/public/membershipLandingPage/membershLandingPage';
import { MyAccountLayout } from 'features/components/base/layouts/MyAccountLayout';
import { Newsandstories, NewsandstoriesDetail }  from 'features/components/base/public/news-and-stories/Stories';
import CategoryItem from 'features/components/base/items/CategoryItems';
import aboutus from 'features/components/base/public/about/aboutus';
import MyBids from 'features/components/base/my-bids/MyBids';
import { BuyerRegister } from 'features/components/signin/Register';
import Explore from 'features/components/base/items/Explore';
/**
 * 
 * routing for base components
 * 
 * @param props
 * 
 * @return routing for base components
 * 
**/

export class AppRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/`} component={Home} />
                {/* <Route path={`/advance-search`} component={AdvanceSearchRouter} /> */}
                <Route path={[`/estate-sale`, `/estate-sale-item`]} component={EstateSalesRouter} />
                <Route path={[`/locations`, `/estate-sales`]} component={LocationsRouter} />
                <Route exact path={`/payment`} component={Payment} />
                <Route exact path={`/payment/invoice/:invoiceId`} component={Payment} />
                <Route exact path={`/help/:section`} component={HelpPage} />
                <Route path={`/plans`} component={membershipplan} />
                <Route exact path={'/stories'} component={Newsandstories} />
                <Route exact path={'/stories/:heading'} component={NewsandstoriesDetail} />
                <Route exact path={'/ourstory'} component={OurStory} />
                <Route exact path={'/premier-membership'} component={membershLandingPage} />
                <Route exact path={['/watching', `/watching/:saleId/item/:itemId`]}
                    component={Watching} />
                <Route path={'/my-account'} component={MyAccountLayout}></Route>
                <Route path={`/register`} component={BuyerRegister} />

                <Route path={'/notification'} component={Notifications}></Route>
                <Route exact path={`/profile`} component={Profile} />
                <Route exact path={`/about/:section`} component={About} />
                <Route exact path={`/about`} component={aboutus} />
                <Route exact path={`/set-password`} component={BuyerRegister} />

                <Route exact path={`/terms`} component={SignTermsAndCondtions} />
                <Route exact path={`/privacy`} component={Privacy} />

                <Route exact path={[`/view-more-items/:type`, `/view-more-items/:saleId/item/:itemId`]} component={ViewMoreItems} ></Route>
                <Route exact path={`/payment-autodebit`} component={PaymentAutoDebit} />
                <Route exact path={[`/paypal-sdk/:buyerId`]} component={PaypalSDK} />
                <Route exact path={`/vault/verification/:paypalkey`} component={PaymentMethodsAdd} />
                <Route exact path={`/vault/cancel`} component={PaymentMethodsAdd} />
                <Route exact path={`/category_list/:category`} component={CategoryItem} />
                <Route exact path={`/my-bids`} component={MyBids} />
                {/* <Route exact path={[`/:categoryname/:subcategoryname`, `/:categoryname`, `/:subcategoryname`]} component={CategoryPage} /> */}
                <Route exact path={[`/category`,`/category/:categoryGroup/:category`, `/category/:categoryGroup`]} component={CategoryItem} />
                <Route exact path={`/explore`} component={Explore} />
                <Redirect to="/" />
            </Switch >
        );
    }
}
